import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSun = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 74,
	height: 73,
	viewBox: "0 0 74 73",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_43_105)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M38.88 4.23999L40.16 2.23999L41 4.46999C41.7 6.33999 44.11 6.84999 45.51 5.42999L47.18 3.73999L47.54 6.08999C47.84 8.06999 50.09 9.06999 51.75 7.96999L53.74 6.65999L53.6 9.03999C53.48 11.03 55.47 12.48 57.33 11.75L59.55 10.88L58.92 13.17C58.39 15.1 60.04 16.92 62.01 16.6L64.36 16.21L63.26 18.32C62.34 20.09 63.57 22.22 65.57 22.31L67.95 22.42L66.44 24.26C65.17 25.8 65.93 28.14 67.87 28.65L70.17 29.25L68.31 30.74C66.75 31.99 67.01 34.43 68.79 35.33L70.92 36.4L68.79 37.47C67 38.37 66.75 40.81 68.31 42.06L70.17 43.55L67.87 44.15C65.94 44.65 65.18 46.99 66.44 48.54L67.95 50.38L65.57 50.49C63.57 50.58 62.34 52.71 63.26 54.48L64.36 56.59L62.01 56.2C60.04 55.87 58.39 57.7 58.92 59.63L59.55 61.92L57.33 61.05C55.47 60.32 53.48 61.77 53.6 63.76L53.74 66.14L51.75 64.83C50.08 63.73 47.83 64.73 47.54 66.71L47.18 69.06L45.51 67.37C44.11 65.95 41.7 66.46 41 68.33L40.16 70.56L38.88 68.56C37.8 66.88 35.34 66.88 34.27 68.56L32.99 70.56L32.15 68.33C31.45 66.46 29.04 65.95 27.64 67.37L25.97 69.06L25.61 66.71C25.31 64.73 23.06 63.73 21.4 64.83L19.41 66.14L19.55 63.76C19.67 61.77 17.68 60.32 15.82 61.05L13.6 61.92L14.23 59.63C14.76 57.7 13.11 55.88 11.14 56.2L8.78997 56.59L9.87997 54.48C10.8 52.71 9.56997 50.58 7.56997 50.49L5.18997 50.38L6.69997 48.54C7.96997 47 7.20997 44.66 5.26997 44.15L2.96997 43.55L4.82997 42.06C6.38997 40.81 6.12997 38.37 4.34997 37.47L2.21997 36.4L4.34997 35.33C6.13997 34.43 6.38997 31.99 4.82997 30.74L2.96997 29.25L5.26997 28.65C7.19997 28.15 7.95997 25.81 6.69997 24.26L5.18997 22.42L7.56997 22.31C9.56997 22.22 10.8 20.09 9.87997 18.32L8.78997 16.21L11.14 16.6C13.11 16.93 14.76 15.1 14.23 13.17L13.6 10.88L15.82 11.75C17.68 12.48 19.67 11.03 19.55 9.03999L19.41 6.65999L21.4 7.96999C23.07 9.06999 25.32 8.06999 25.61 6.08999L25.97 3.73999L27.64 5.42999C29.04 6.84999 31.45 6.33999 32.15 4.46999L32.99 2.23999L34.27 4.23999C35.35 5.91999 37.81 5.91999 38.88 4.23999Z",
				stroke: "white",
				strokeWidth: 4.48,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M38.88 4.23999L40.16 2.23999L41 4.46999C41.7 6.33999 44.11 6.84999 45.51 5.42999L47.18 3.73999L47.54 6.08999C47.84 8.06999 50.09 9.06999 51.75 7.96999L53.74 6.65999L53.6 9.03999C53.48 11.03 55.47 12.48 57.33 11.75L59.55 10.88L58.92 13.17C58.39 15.1 60.04 16.92 62.01 16.6L64.36 16.21L63.26 18.32C62.34 20.09 63.57 22.22 65.57 22.31L67.95 22.42L66.44 24.26C65.17 25.8 65.93 28.14 67.87 28.65L70.17 29.25L68.31 30.74C66.75 31.99 67.01 34.43 68.79 35.33L70.92 36.4L68.79 37.47C67 38.37 66.75 40.81 68.31 42.06L70.17 43.55L67.87 44.15C65.94 44.65 65.18 46.99 66.44 48.54L67.95 50.38L65.57 50.49C63.57 50.58 62.34 52.71 63.26 54.48L64.36 56.59L62.01 56.2C60.04 55.87 58.39 57.7 58.92 59.63L59.55 61.92L57.33 61.05C55.47 60.32 53.48 61.77 53.6 63.76L53.74 66.14L51.75 64.83C50.08 63.73 47.83 64.73 47.54 66.71L47.18 69.06L45.51 67.37C44.11 65.95 41.7 66.46 41 68.33L40.16 70.56L38.88 68.56C37.8 66.88 35.34 66.88 34.27 68.56L32.99 70.56L32.15 68.33C31.45 66.46 29.04 65.95 27.64 67.37L25.97 69.06L25.61 66.71C25.31 64.73 23.06 63.73 21.4 64.83L19.41 66.14L19.55 63.76C19.67 61.77 17.68 60.32 15.82 61.05L13.6 61.92L14.23 59.63C14.76 57.7 13.11 55.88 11.14 56.2L8.78997 56.59L9.87997 54.48C10.8 52.71 9.56997 50.58 7.56997 50.49L5.18997 50.38L6.69997 48.54C7.96997 47 7.20997 44.66 5.26997 44.15L2.96997 43.55L4.82997 42.06C6.38997 40.81 6.12997 38.37 4.34997 37.47L2.21997 36.4L4.34997 35.33C6.13997 34.43 6.38997 31.99 4.82997 30.74L2.96997 29.25L5.26997 28.65C7.19997 28.15 7.95997 25.81 6.69997 24.26L5.18997 22.42L7.56997 22.31C9.56997 22.22 10.8 20.09 9.87997 18.32L8.78997 16.21L11.14 16.6C13.11 16.93 14.76 15.1 14.23 13.17L13.6 10.88L15.82 11.75C17.68 12.48 19.67 11.03 19.55 9.03999L19.41 6.65999L21.4 7.96999C23.07 9.06999 25.32 8.06999 25.61 6.08999L25.97 3.73999L27.64 5.42999C29.04 6.84999 31.45 6.33999 32.15 4.46999L32.99 2.23999L34.27 4.23999C35.35 5.91999 37.81 5.91999 38.88 4.23999Z",
				fill: "url(#paint0_linear_43_105)"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M36.57 61.06C50.1948 61.06 61.24 50.0148 61.24 36.39C61.24 22.7651 50.1948 11.72 36.57 11.72C22.9451 11.72 11.9 22.7651 11.9 36.39C11.9 50.0148 22.9451 61.06 36.57 61.06Z",
				fill: "url(#paint1_linear_43_105)"
			}),
			/* @__PURE__ */ _jsx("path", {
				style: { mixBlendMode: "soft-light" },
				d: "M35.9556 34.509C43.1015 29.5978 46.3255 21.8787 43.1567 17.268C39.9879 12.6573 31.6261 12.901 24.4802 17.8122C17.3343 22.7234 14.1103 30.4425 17.2791 35.0532C20.448 39.6639 28.8097 39.4202 35.9556 34.509Z",
				fill: "url(#paint2_linear_43_105)"
			}),
			/* @__PURE__ */ _jsx("path", {
				style: { mixBlendMode: "color-burn" },
				opacity: .05,
				d: "M48.13 14.59C52.01 18.95 54.38 24.69 54.38 30.99C54.38 44.61 43.34 55.66 29.71 55.66C25.53 55.66 21.6 54.62 18.15 52.78C22.67 57.85 29.24 61.05 36.57 61.05C50.19 61.05 61.24 50.01 61.24 36.38C61.24 26.93 55.93 18.73 48.13 14.59Z",
				fill: "url(#paint3_linear_43_105)"
			})
		]
	}), /* @__PURE__ */ _jsxs("defs", { children: [
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_43_105",
			x1: 63.05,
			y1: 59.12,
			x2: 11.37,
			y2: 14.75,
			gradientUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("stop", {
					offset: .07,
					stopColor: "#F9DF4B"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .27,
					stopColor: "#F6D347"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .48,
					stopColor: "#F6D047"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .74,
					stopColor: "#F4BC41"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .77,
					stopColor: "#F3BA40"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#F3B53F"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint1_linear_43_105",
			x1: 15.32,
			y1: 20.62,
			x2: 59.88,
			y2: 53.67,
			gradientUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("stop", { stopColor: "#F9DF4B" }),
				/* @__PURE__ */ _jsx("stop", {
					offset: .14,
					stopColor: "#F6D347"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .28,
					stopColor: "#F6D047"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .67,
					stopColor: "#F4BC41"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#F3B53F"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint2_linear_43_105",
			x1: 21.1439,
			y1: 14.9084,
			x2: 47.0039,
			y2: 46.9984,
			gradientUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("stop", { stopColor: "white" }),
				/* @__PURE__ */ _jsx("stop", {
					offset: .34,
					stopColor: "#B6B5B5"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#221F20"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint3_linear_43_105",
			x1: 88.2,
			y1: 55.24,
			x2: 32.32,
			y2: 34.97,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "white" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#221F20"
			})]
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_43_105",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 73.15,
				height: 72.77,
				fill: "white"
			})
		})
	] })]
});
export default SvgSun;
